// Which HTTP answers to a write the phone retries. ONE source for both sides:
// the phone's outbox (apps/mobile/src/outbox/errorDisposition.ts) retries on
// it, and the API's idempotency cache (apps/api/src/idempotency.ts) refuses
// to store it, because a retried status replayed for 24h under the same key
// would answer every retry and strand the write.

// 401 not_authenticated (token not ready yet on a cold foreground, or a
// refresh that could not reach Cognito), 408 Request Timeout, 425 Too
// Early, 429 Too Many Requests: all transient, the same replay can succeed
// once auth restores or the server cools down.
export const TRANSIENT_STATUSES: ReadonlySet<number> = new Set([
  401, 408, 425, 429,
]);

/**
 * True when the phone retries a write answered with `status`.
 *
 * Beyond the transient set, a 404 on a POST: a POST targets a collection,
 * which always exists, so a 404 there means not yet (or not our server), never
 * a product verdict. An undeclared verb reads as POST, the outbox's own rule.
 */
export const isRetriedStatus = (status: number, method?: string): boolean =>
  TRANSIENT_STATUSES.has(status) ||
  (status === 404 && (method === undefined || method === "POST"));
